export default "__VITE_ASSET__99MNPCbu__"